import styled from "styled-components";

import { MOBILE_BREAKPOINT } from "features/StopList/styles";

export const Toolbar = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;

    @media (max-width: ${MOBILE_BREAKPOINT - 1}px) {
        gap: 8px;
    }
`;

export const Wide = styled.div`
    @media (max-width: ${MOBILE_BREAKPOINT - 1}px) {
        display: none;
    }
`;

export const Compact = styled.div`
    display: none;

    @media (max-width: ${MOBILE_BREAKPOINT - 1}px) {
        display: block;
    }
`;
